import React, { Component } from 'react';
import {
    isInitialLoadSelector,
    isSessionValidSelector,
    loginErrorSelector,
    loginStatusSelector
} from '../selectors/ui-state-selectors';

import {
    login,
    validateSession,
} from '../actions/authentication-action-creators';

import Login from '../components/login';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    getCookie,
    setCookie
} from '../../utils/cookie-utils';

export class LoginContainer extends Component{
    constructor( props ){
        super( props );

        const savedLoginEmail = getCookie( 'login_email' );

        this.state = {
            loginError: false,
            savedLoginEmail: savedLoginEmail || ''
        };
    }

    componentDidMount(){
        const { validateSession } = this.props;
        validateSession();
    }

    handleLogin = ( username ) => {
        setCookie( 'login_email', username );
        this.props.login( username );
    }

    render(){
        const { from } = this.props.location.state || { from: { pathname: '/' } };

        const {
            isSessionValid,
            loginError,
            loginStatus,
        } = this.props;
        const { savedLoginEmail } = this.state;

        if( isSessionValid ){
            return <Redirect to={from} />;
        }

        return (

            <Login
                handleLogin={this.handleLogin}
                loginError={loginError}
                loginStatus={loginStatus}
                savedLoginEmail={savedLoginEmail}
            />

        );
    }
}

LoginContainer.propTypes = {
    isRedirectToLogin: PropTypes.bool,
    isSessionValid: PropTypes.bool,
    location: PropTypes.any,
    login: PropTypes.func,
    loginError: PropTypes.bool,
    loginStatus: PropTypes.number,
    validateSession: PropTypes.func,
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isInitialLoad: isInitialLoadSelector( state ),
        isSessionValid: isSessionValidSelector( state ),
        loginError: loginErrorSelector( state ),
        loginStatus: loginStatusSelector( state ),
    };
};

export default connect( mapStateToProps, { login, validateSession } )( LoginContainer );
